module.exports = __webpack_public_path__ + "static/media/page1pic2.e3af8410.jpg";